module.exports = "module.exports = __webpack_public_path__ + \"static/media/tableFooterSigner.32d12052.template\";"